// FavouriteItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class FavouriteItemBase extends Component {
  constructor (props) {
    super(props)

    this.data = {
      disableClick: false
    }
  }

  static propTypes = {
    item: PropTypes.object,
    currentUser: PropTypes.bool,
    showEdit: PropTypes.bool,
    index: PropTypes.number,
    isDragging: PropTypes.bool,
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    onMoveItem: PropTypes.func,
    onDragEnd: PropTypes.func,
    dragItem: PropTypes.object
  };

  render () {
    const {
      item,
      currentUser,
      showEdit,
      dragItem,
      onDelete
    } = this.props
    if (!item) {
      return null
    }

    const isAllowedToUseCard = true

    const _className = classnames('favourite-item', {
      disableedit: !isAllowedToUseCard,
      isdraggable: showEdit,
      isdragging: dragItem && dragItem.id === item.id,
      disableclick: this.data.disableClick
    })

    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource
    const connectDropTarget = this.props.connectDropTarget
      ? this.props.connectDropTarget
      : this._connectDropTarget
    const activityOptions = [
      { label: 'time.item.activityHoliday', value: 'Holiday' },
      { label: 'time.item.activitySickLeave', value: 'SickLeave' },
      { label: 'time.item.activityMeeting', value: 'Meeting' },
      { label: 'time.item.activityTraining', value: 'Training' },
      { label: 'time.item.activityDoctorOrDentist', value: 'Doctor/Dentist' },
      { label: 'time.item.activityOther', value: 'Other' }
    ]
    const activityIdent = _.find(
      activityOptions,
      (activityOption) => activityOption.value === item.customActivityType
    )

    return connectDragSource(
      connectDropTarget(
        <div
          className={_className}
          onClick={this.data.disableClick ? null : this._onClick.bind(this)}
          key={item.id}
        >
          {item.project ? (
            <div className='cont'>
              <div className='title'>{item.project.title}</div>
              <span className='info'>{item.customActivityType}</span>
            </div>
          ) : (
            <div className='cont normal'>
              <div className='title'>
                {activityIdent ? (
                  <IntlMessage ident={activityIdent.label} />
                ) : (
                  ''
                )}
              </div>
            </div>
          )}
          {currentUser && showEdit && (
            <IconButton
              icon='common-item-delete'
              size='small'
              className='purchaseview'
              onClick={onDelete}
              canHover={false}
            />
          )}
        </div>
      )
    )
  }

  /* Event handlers */
  _onClick (ev) {
    if (!this.data.disableClick && this.props.onClick) {
      if (this._clickTimer) window.clearTimeout(this._clickTimer)

      this.data.disableClick = true
      this.setState({ dataDate: new Date() })

      this.props.onClick(ev, () => {
        this._clickTimer = window.setTimeout(() => {
          this.data.disableClick = false
          this.setState({ dataDate: new Date() })
        }, 1000)
      })
    }
  }

  /* Private functions */
  _connectDragSource (node) {
    return node
  }

  _connectDropTarget (node) {
    return node
  }
}

export default FavouriteItemBase
